import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ThreeSixtyIcon from '@mui/icons-material/ThreeSixty';

export function PatrolViewerEmptyState() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        gap: 3,
        p: 4,
      }}
    >
      <ThreeSixtyIcon
        sx={{
          fontSize: 100,
          color: "#D1D5DB",
        }}
      />
       <Typography
        sx={{
          fontFamily: "Roboto, sans-serif",
          fontSize: "16px",
          fontWeight: 600,
          color: "#4A5565",
        }}
      >
        No Patrol Selected
      </Typography>
      <Typography
        sx={{
          fontFamily: "Roboto, sans-serif",
          fontSize: "14px",
          color: "#6B7280",
          textAlign: "center",
          maxWidth: "500px",
        }}
      >
        Select a patrol from the list to view its 360° panoramic recording
      </Typography>
    </Box>
  );
}

